(function () {
	'use strict';
	MxGridCurrencyCtrl.$inject = ['uiGridEditConstants', 'uiGridConstants', '$scope', '$element'];

	function MxGridCurrencyCtrl(uiGridEditConstants, uiGridConstants, $scope, $element) {
		var vm = this;
		vm.$onInit = function () {
			var colDef = vm.col.colDef;
			var val = vm.row.entity[colDef.field];
			if (val) {
				vm.model = {
					CC: val.CC,
					Value: val.Value,
				};
			}

			function save() {
				vm.row.entity[colDef.field] = vm.model;
				$scope.$emit(uiGridEditConstants.events.END_CELL_EDIT);
			}

			vm.onBlur = function () {
				save();
			};

			$element.on('keydown', function (evt) {
				switch (evt.keyCode) {
					case uiGridConstants.keymap.ESC:
						evt.stopPropagation();
						$scope.$emit(uiGridEditConstants.events.CANCEL_CELL_EDIT);
						break;
					case uiGridConstants.keymap.ENTER: // Enter (Leave Field)
					case uiGridConstants.keymap.TAB:
						evt.stopPropagation();
						evt.preventDefault();
						save();
						break;
				}

				return true;
			});

			$scope.$on('$destroy', function unbindEvents() {
				// unbind jquery events to prevent memory leaks
				$element.off();
			});
		};

		return vm;
	}

	/**
	 * @ngdoc directive
	 * @name mx.components:mxGridCurrency
	 * @module mx.components
	 * @restrict 'E'
	 * @description
	 * The mx-grid-select control is used in mx-grid for inline editing
	 *
	 * @usage <mx-grid-currency data-col="col" data-row="row"></mx-grid-currency>
	 */
	angular.module('mx.components').directive('mxGridCurrency', [
		function mxGridCurrencyDirective() {
			return {
				scope: {},
				restrict: 'E',
				bindToController: {
					col: '=',
					row: '=',
				},
				controller: MxGridCurrencyCtrl,
				controllerAs: 'vm',
				template: [
					function () {
						return (
							'' +
							'<mx-currency ' +
							'ng-class="\'colt\' + vm.col.uid" ' +
							'ng-model="vm.model" ' +
							'data-on-blur="vm.onBlur()" ' +
							'focus-on-init="true" ' +
							'allowmulti="false" ' +
							'config="vm.col.colDef.editDropdownOptionsArray">' +
							'</mx-currency>' +
							''
						);
					},
				],
			};
		},
	]);
})();
